import * as _ from 'lodash';
import {
    NotificationType,
    ResultsStatus
} from '../../models';

export const notificationsSearchCriteria = [
    {
        label: 'Notification type',
        model: 't',
        placeholder: 'Notification type',
        property: 't',
        isMatch: (nvm, regex, originalString) => {
            return regex.test(_.lowerCase(NotificationType[nvm.type]));
        }
    },
    {
        label: 'Application',
        model: 'a',
        placeholder: 'Application',
        property: 'a',
        isMatch: (nvm, regex, originalString) => {
            return regex.test(nvm.applicationName);
        }
    },
    {
        label: 'Severity',
        model: 's',
        placeholder: 'Severity (Ok, Warning, Error)',
        property: 's',
        isMatch: (nvm, regex, originalString) => {
            return regex.test(ResultsStatus[nvm.status]);
        }
    }
];